(function () {
    'use strict';

    angular.module("imApp").factory("currencyExRatesService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1021,
                    parameters: parms || {}
                });
            },
            listCurrencyExRates: function (parms) {
                return $ihttp.post({
                    method: 1022,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
